import React from 'react'
import { Row, Col } from "antd";
import styled from 'styled-components';
import '../../pages/Landing/Landing.css';
import PurposeCommit1 from './Commitments/PurposeCommit1';
import PurposeCommit2 from './Commitments/PurposeCommit2';
import PurposeCommit3 from './Commitments/PurposeCommit3';
import PurposeCommit4 from './Commitments/PurposeCommit4';

const StyledDiv = styled.div`
    font-family: "Poppins", sans-serif;
`;

export const PurposeText = () => {
    return (
        <>
            <Row
                className="purposeTextContainer"
            >
                <Col
                    span={24}
                    style={{
                        height: "100%"
                    }}
                >
                    <Row
                        style={{
                            height: "10%"
                        }}
                    >
                        <Col
                            span={24}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <StyledDiv>
                                <p
                                    className="subCatText"
                                >Commitments and Principles</p>
                            </StyledDiv>
                        </Col>
                    </Row>

                    <Row
                        style={{
                            height: "90%"
                        }}

                        className="purposeCommitmentsContainer"
                    >
                        <Col
                            xl={{span: 6}}
                            lg={{span: 6}}
                            md={{span: 24}}
                            sm={{span: 24}}
                            xs={{span: 24}}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <PurposeCommit1 />
                        </Col>

                        <Col
                            xl={{span: 6}}
                            lg={{span: 6}}
                            md={{span: 24}}
                            sm={{span: 24}}
                            xs={{span: 24}}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <PurposeCommit2 />
                        </Col>

                        <Col
                            xl={{span: 6}}
                            lg={{span: 6}}
                            md={{span: 24}}
                            sm={{span: 24}}
                            xs={{span: 24}}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <PurposeCommit3 />
                        </Col>

                        <Col
                            xl={{span: 6}}
                            lg={{span: 6}}
                            md={{span: 24}}
                            sm={{span: 24}}
                            xs={{span: 24}}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <PurposeCommit4 />
                        </Col>
                    </Row>
                </Col>
            </Row>
            {/* <Row justify="center"
                style={{
                    padding: "30px",
                }}
            >
                <Col span={24} style={{ textAlign: 'start', paddingLeft: "30px" }}>
                    <PurposeCommit1 />
                    <br />

                    <PurposeCommit2 />
                    <br />

                    <PurposeCommit3 />
                    <br />

                    <PurposeCommit4 />
                    <br />
                </Col>
            </Row> */}
        </>
    )
}
